import api from './api';

const penaltyService = {
  // Get all penalties (landlord)
  getAllPenalties: () => {
    return api.get('/api/penalties');
  },

  // Get penalties summary for landlord dashboard
  getPenaltiesSummary: () => {
    return api.get('/api/penalties/summary');
  },

  // Get current tenant's penalties
  getMyPenalties: () => {
    return api.get('/api/penalties/me');
  },
};

export default penaltyService;
